import CarouselWrapper from './CarouselWrapper';
export default CarouselWrapper;
//# sourceMappingURL=index.js.map